import React from 'react';
import OpenPreviewProductDetail from '../../../../containers/app/common/OpenPreviewProductDetail';
import Panel from '../../../../components/outline/Panel';
import LabelInfo from '../../../../components/LabelInfo';
import OpenBrandDetail from '../../../../components/link/OpenBrandDetail';
import OpenProductDetail from '../../../../components/link/OpenProductDetail';
import Slider from '../../../../components/utils/Slider';
import Img from '../../../../components/Img';
import { setDash, setPhoneFormat, setNumberWithComma } from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';
import { AMONDZ_MEMBER_TYPE, DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import SendMessageService from '../../../../containers/app/common/SendMessageService';
import './CsDetailProductInfo.scss';

const CsDetailProductInfo = (props) => {
  const { productInfo } = props;
  const {
    productId,
    mainCategory,
    subCategory,
    productName,
    storeId,
    storeName,
    storeTier,
    originPrice,
    discountPrice,
    salesPrice,
    discountPeriod,
    createDate,
    images,
    storeCellPhone,
    sellerCellPhone,
  } = productInfo;

  return (
    <Panel className="cs-detail-product-info">
      <div className="panel-header">
        <div className="title">상품 정보</div>
      </div>

      <div className="panel-body">
        <div className="product-info-wrap">
          <div className="product-info">
            <div className="form-wrap">
              <LabelInfo label="상품번호" info={<OpenProductDetail text={productId} productId={productId} />} />

              <LabelInfo label="상품명" info={<OpenPreviewProductDetail text={productName} productId={productId} />} />

              <LabelInfo label="1차 카테고리" info={mainCategory} />

              <LabelInfo label="상품 할인액" info={setNumberWithComma(discountPrice)} />

              <LabelInfo label="실판매가" info={setNumberWithComma(salesPrice)} />
            </div>

            <div className="form-wrap">
              <LabelInfo label="브랜드명" info={<OpenBrandDetail text={storeName} storeId={storeId} />} />

              <LabelInfo label="브랜드 티어" info={setDash(storeTier)} />

              <LabelInfo label="2차 카테고리" info={subCategory} />

              <LabelInfo
                label="판매자 전화번호"
                info={
                  <SendMessageService
                    text={setPhoneFormat(sellerCellPhone)}
                    memberType={AMONDZ_MEMBER_TYPE.SELLER}
                    targetId={storeId}
                  />
                }
              />
            </div>

            <div className="form-wrap">
              <LabelInfo label="판매가" info={setNumberWithComma(originPrice)} />

              <LabelInfo label="할인기간" info={setDash(discountPeriod)} />

              <LabelInfo label="브랜드 전화번호" info={setPhoneFormat(storeCellPhone)} />

              <LabelInfo label="등록일" info={setDateFormat(createDate, DATE_FORMAT.YMD_HM_DASH_FORMAT)} />
            </div>
          </div>

          <div className="product-images">
            <Slider
              className="product-images-slider"
              emptyText="상품 이미지가 없습니다."
              list={images}
              item={(url) => (
                <div className="product-image">
                  <Img src={url} />
                </div>
              )}
            />
          </div>
        </div>
      </div>
    </Panel>
  );
};

export default CsDetailProductInfo;
